import React from 'react';
import * as diff from "diff";
import PropTypes from "prop-types";
import AuditInput from "./AuditInput";

const renderDiffJs = (before = "", after = "", mode = "words") => {
    let groups = [];

    if (mode === "characters")
        groups = diff.diffChars(before, after);
    if (mode === "words")
        groups = diff.diffWordsWithSpace(before, after);
    if (mode === "lines")
        groups = diff.diffLines(before, after, { newlineIsToken: true });
    if (mode === "sentences")
        groups = diff.diffSentences(before, after, { newlineIsToken: true });

    const mappedNodes = groups.map(group => {
        let { value } = group;
        const {added, removed } = group;
        // preprocess newline characters (only newline, ignore full paragraph change) into pilcrow (¶)
        if ((added || removed) && !/\S/.test(value)) {
            const linebreaks = value.match(/(\r\n|\r|\n)/g);
            if (linebreaks) {
                if (removed)
                    value = `\u00b6`.repeat(linebreaks.length);
                if (added)
                    value = `\u00b6\n`.repeat(linebreaks.length);
            }
        }

        let nodeClassName;
        if (added)
            nodeClassName = "row-added";
        if (removed)
            nodeClassName = "row-removed--red";
        return <span className={nodeClassName}>{value}</span>;
    });

    return <span style={{ whiteSpace: "pre-wrap" }}>{mappedNodes}</span>;
};

function AuditInputDiffJs({ before = "", after = "", mode = "words", ...restProps }) {
    return (
        <AuditInput
            customRenderInput={
                {
                    renderEditDiv: () => renderDiffJs(before, after, mode),
                }
            }
            before={before}
            after={after}
            {...restProps}
        />
    );
}

AuditInputDiffJs.propTypes = {
    before: PropTypes.string,
    after: PropTypes.string,
    mode: PropTypes.oneOf(["characters", "words", "lines", "sentences"]),
};

export default AuditInputDiffJs;
